import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Routes from "./Routes";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import ls from "localstorage-slim";
import { moralis_api_key } from "./config/config.js";

function App() {
  
  fetch("https://deep-index.moralis.io/api/v2/erc20/0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2/price?chain=eth", {
    headers: {
        'accept': 'application/json',
         'X-API-Key': moralis_api_key
      }    
    }).then((res) => {
      res.json().then((data) => {
        console.log(data.usdPrice);
        ls.set("eth-usd", data.usdPrice, { ttl: 600 });
    });
  });
  

  fetch("https://deep-index.moralis.io/api/v2/erc20/0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0/price?chain=eth", {
    headers: {
      'accept': 'application/json',
       'X-API-Key': moralis_api_key
    }    
  }).then((res) => {
      res.json().then((data) => {
        console.log(data.usdPrice);
        ls.set("matic-usd", data.usdPrice, { ttl: 600 });
      });
  });

  return (
    <div className="App">
      <Router>
        <Header />
        <Routes />
        <Footer />
      </Router>
    </div>
  );
}

export default App;
